// src/utils/actionCreators.js

// Generalisierte Action-Types
export const createActionType = (base) => ({
    REQUEST: `${base}_REQUEST`,
    SUCCESS: `${base}_SUCCESS`,
    FAILURE: `${base}_FAILURE`,
});

// Generalisierte Action-Creator
export const createActionCreators = (base) => {
    const actionType = createActionType(base);

    return {
        request: (payload) => ({ type: actionType.REQUEST, payload }),
        success: (payload) => ({ type: actionType.SUCCESS, payload }),
        failure: (payload) => ({ type: actionType.FAILURE, payload })
    };
};
